(function () {
  if (window.__saInit) return;
  window.__saInit = true;

  var T = {
    it: {
      btn: 'Verifica disponibilit\u00e0 in negozio',
      notice: 'Attenzione! Non possiamo garantire la presenza della taglia desiderata. Per conoscere la disponibilit\u00e0 effettiva, contatta direttamente il negozio di tuo interesse.',
      search: 'Cerca un luogo (citt\u00e0 o CAP)',
      mono: 'Monobrand', multi: 'Multibrand',
      stores: 'negozi', store: 'negozio',
      dir: 'Ottieni indicazioni',
      empty: 'Nessun negozio trovato con questi filtri.',
      loading: 'Caricamento\u2026', error: 'Impossibile caricare i negozi. Riprova pi\u00f9 tardi.',
      close: 'Chiudi', locator: 'Vai allo store locator', found: 'trovati', foundOne: 'trovato', call: 'Chiama', route: 'Indicazioni', nearActive: 'Vicino a me', noticeMore: 'Leggi', noticeShort: 'Non garantiamo la taglia. Contatta il negozio.',
      air: 'in linea d\'aria', road: 'in auto', tabList: 'Elenco', tabMap: 'Visualizza sulla mappa', near: 'Vicino a me', within: 'entro', locFail: 'Posizione non disponibile', mapFail: 'Impossibile caricare la mappa.'
    },
    en: {
      btn: 'Check availability in store',
      notice: 'Please note: we cannot guarantee that your size is in stock. To find out the actual availability, please contact the store directly.',
      search: 'Search a place (city or postcode)',
      mono: 'Monobrand', multi: 'Multibrand',
      stores: 'stores', store: 'store',
      dir: 'Get directions',
      empty: 'No stores found with these filters.',
      loading: 'Loading\u2026', error: 'Unable to load stores. Please try again later.',
      close: 'Close', locator: 'Go to the store locator', found: 'found', foundOne: 'found', call: 'Call', route: 'Directions', nearActive: 'Near me', noticeMore: 'Read', noticeShort: 'Size not guaranteed. Contact the store.',
      air: 'as the crow flies', road: 'by car', tabList: 'List', tabMap: 'View on map', near: 'Near me', within: 'within', locFail: 'Location unavailable', mapFail: 'Unable to load the map.'
    },
    de: {
      btn: 'Verf\u00fcgbarkeit im Gesch\u00e4ft pr\u00fcfen',
      notice: 'Achtung! Wir k\u00f6nnen nicht garantieren, dass Ihre Gr\u00f6\u00dfe vorr\u00e4tig ist. Bitte kontaktieren Sie das Gesch\u00e4ft direkt, um die tats\u00e4chliche Verf\u00fcgbarkeit zu erfahren.',
      search: 'Ort suchen (Stadt oder PLZ)',
      mono: 'Monobrand', multi: 'Multibrand',
      stores: 'Gesch\u00e4fte', store: 'Gesch\u00e4ft',
      dir: 'Route anzeigen',
      empty: 'Mit diesen Filtern wurden keine Gesch\u00e4fte gefunden.',
      loading: 'Wird geladen\u2026', error: 'Die Gesch\u00e4fte konnten nicht geladen werden. Bitte sp\u00e4ter erneut versuchen.',
      close: 'Schlie\u00dfen', locator: 'Zum Store Locator', found: 'gefunden', foundOne: 'gefunden', call: 'Anrufen', route: 'Route', nearActive: 'In meiner N\u00e4he', noticeMore: 'Lesen', noticeShort: 'Gr\u00f6\u00dfe nicht garantiert. Gesch\u00e4ft kontaktieren.',
      air: 'Luftlinie', road: 'mit dem Auto', tabList: 'Liste', tabMap: 'Auf Karte anzeigen', near: 'In meiner N\u00e4he', within: 'im Umkreis von', locFail: 'Standort nicht verf\u00fcgbar', mapFail: 'Die Karte konnte nicht geladen werden.'
    }
  };

  var DEFAULT_TOKEN = '16a8f15c2c5e7e';
  var ID_FIELD = '0ao1qzzshj';          // campo ID nell'endpoint del widget (fallback)
  var STORES_KEY = 'frau_sa_stores_v2', FILE_KEY = 'frau_sa_file_v1';
  var STORES_TTL = 12 * 3600 * 1000;
  var mem = {};

  /* ---------- utilit\u00e0 ---------- */
  function norm(s) { return String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase(); }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function flag(v, def) { return v === '' || v == null ? def : v !== 'false'; }
  function masterSku(s) { return String(s || '').trim().replace(/_\d+$/, ''); }
  // 060183-52-calzature-benvenuti -> 60183-52  (stessa logica dello script Python)
  function handleToId(h) {
    var m = /^(\d{6})(?:-(\d{1,2}bis|\d{1,2}|[a-z]\d+))?-/i.exec(String(h || '').trim());
    if (!m) return null;
    return (m[1].replace(/^0+/, '') + (m[2] ? '-' + m[2] : '')).toLowerCase();
  }
  // 60611 / 060611 / 60572-51 / 60611-bis  ->  id come in Storepoint (formato "Codice cliente" del foglio AI26)
  function codeToId(c) {
    var m = /^0*(\d{1,6})(?:\.0+)?(?:-(\d{1,2}bis|\d{1,2}|[a-z]\d+))?$/i.exec(String(c || '').trim());
    if (!m) return null;
    return (m[1] + (m[2] ? '-' + m[2] : '')).toLowerCase();
  }
  // un codice nudo che in Storepoint non esiste da solo vale per tutti i suoi punti vendita (60611 -> 60611-51 ... -66)
  function expandIds(ids, have) {
    var out = {}, byBase = {};
    Object.keys(have).forEach(function (k) { var b = k.split('-')[0]; if (b !== k) (byBase[b] = byBase[b] || []).push(k); });
    ids.forEach(function (i) {
      i = String(i).toLowerCase();
      if (have[i] || i.indexOf('-') > -1) { out[i] = 1; return; }
      (byBase[i] || []).forEach(function (k) { out[k] = 1; });
    });
    return Object.keys(out);
  }
  function loadData(src, cb) {
    if (window.FRAU_STORE_AVAILABILITY) return cb();
    var s = document.createElement('script');
    s.src = src; s.onload = cb; s.onerror = cb;
    document.head.appendChild(s);
  }

  /* ---------- lettura del file di Frau (xlsx o csv) ---------- */
  function decodeXml(s) {
    return s.replace(/&#x([0-9a-f]+);/gi, function (_, h) { return String.fromCharCode(parseInt(h, 16)); })
            .replace(/&#(\d+);/g, function (_, n) { return String.fromCharCode(+n); })
            .replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&apos;/g, "'").replace(/&amp;/g, '&');
  }
  function inflateRaw(bytes) {
    var ds = new DecompressionStream('deflate-raw');
    return new Response(new Blob([bytes]).stream().pipeThrough(ds)).arrayBuffer();
  }
  function unzip(buf, wanted) {
    var u8 = new Uint8Array(buf), dv = new DataView(buf), eocd = -1, i;
    for (i = u8.length - 22; i >= Math.max(0, u8.length - 65557); i--) { if (dv.getUint32(i, true) === 0x06054b50) { eocd = i; break; } }
    if (eocd < 0) throw new Error('File non valido (non \u00e8 un .xlsx)');
    var n = dv.getUint16(eocd + 10, true), p = dv.getUint32(eocd + 16, true), files = {};
    for (i = 0; i < n; i++) {
      if (dv.getUint32(p, true) !== 0x02014b50) break;
      var method = dv.getUint16(p + 10, true), csize = dv.getUint32(p + 20, true),
          nlen = dv.getUint16(p + 28, true), elen = dv.getUint16(p + 30, true), clen = dv.getUint16(p + 32, true),
          off = dv.getUint32(p + 42, true), name = new TextDecoder().decode(u8.subarray(p + 46, p + 46 + nlen));
      files[name] = { method: method, csize: csize, off: off };
      p += 46 + nlen + elen + clen;
    }
    var out = {}, jobs = [];
    Object.keys(files).forEach(function (name) {
      if (!wanted(name)) return;
      var f = files[name], lo = f.off, ln = dv.getUint16(lo + 26, true), le = dv.getUint16(lo + 28, true),
          data = u8.subarray(lo + 30 + ln + le, lo + 30 + ln + le + f.csize);
      jobs.push((f.method === 8 ? inflateRaw(data) : Promise.resolve(data.slice().buffer)).then(function (ab) {
        out[name] = new TextDecoder().decode(ab);
      }));
    });
    return Promise.all(jobs).then(function () { return out; });
  }
  function parseXlsx(buf) {
    return unzip(buf, function (n) { return n === 'xl/sharedStrings.xml' || /^xl\/worksheets\/sheet\d+\.xml$/.test(n); }).then(function (f) {
      var sheetName = Object.keys(f).filter(function (n) { return /worksheets/.test(n); }).sort()[0];
      if (!sheetName) throw new Error('Nessun foglio trovato nel file');
      var shared = [];
      if (f['xl/sharedStrings.xml']) {
        (f['xl/sharedStrings.xml'].match(/<si\b[\s\S]*?<\/si>/g) || []).forEach(function (si) {
          var t = ''; (si.match(/<t\b[^>]*>[\s\S]*?<\/t>/g) || []).forEach(function (x) { t += decodeXml(x.replace(/<[^>]+>/g, '')); });
          shared.push(t);
        });
      }
      var rows = [];
      (f[sheetName].match(/<row\b[\s\S]*?<\/row>/g) || []).forEach(function (rx) {
        var row = {};
        (rx.match(/<c\b[^>]*?(?:\/>|>[\s\S]*?<\/c>)/g) || []).forEach(function (cx) {
          var ref = /\br="([A-Z]+)\d+"/.exec(cx); if (!ref) return;
          var type = (/\bt="([a-zA-Z]+)"/.exec(cx) || [])[1], v = /<v>([\s\S]*?)<\/v>/.exec(cx), val = '';
          if (type === 'inlineStr') val = decodeXml((cx.match(/<t\b[^>]*>[\s\S]*?<\/t>/g) || []).map(function (x) { return x.replace(/<[^>]+>/g, ''); }).join(''));
          else if (v) val = type === 's' ? (shared[+v[1]] || '') : decodeXml(v[1]);
          if (val !== '') row[ref[1]] = val;
        });
        rows.push(row);
      });
      return rows;
    });
  }
  function parseCsv(text) {
    text = text.replace(/^\ufeff/, '');
    var first = text.split(/\r?\n/)[0] || '', delim = [';', '\t', ','].sort(function (a, b) { return first.split(b).length - first.split(a).length; })[0];
    var rows = [], row = [], cur = '', q = false, i, c;
    for (i = 0; i < text.length; i++) {
      c = text[i];
      if (q) { if (c === '"') { if (text[i + 1] === '"') { cur += '"'; i++; } else q = false; } else cur += c; }
      else if (c === '"') q = true;
      else if (c === delim) { row.push(cur); cur = ''; }
      else if (c === '\n' || c === '\r') { if (c === '\r' && text[i + 1] === '\n') i++; row.push(cur); cur = ''; rows.push(row); row = []; }
      else cur += c;
    }
    if (cur !== '' || row.length) { row.push(cur); rows.push(row); }
    return rows.filter(function (r) { return r.some(Boolean); }).map(function (r) { var o = {}; r.forEach(function (v, k) { if (v !== '') o[String.fromCharCode(65 + k)] = v; }); return o; });
  }
  // rows: [{A:..,B:..,C:..}] con intestazione nella prima riga
  function tableToData(rows) {
    if (!rows.length) throw new Error('Il file \u00e8 vuoto');
    var head = rows[0], cols = { sku: null, stores: null, code: null };
    Object.keys(head).forEach(function (k) {
      var t = String(head[k]).toLowerCase();
      if (/sku/.test(t)) cols.sku = k; else if (/negoz|store/.test(t)) cols.stores = k; else if (/codice|cliente/.test(t)) cols.code = k;
    });
    if (!cols.sku || !(cols.stores || cols.code)) throw new Error('Colonne non riconosciute: servono "sku" e "codice cliente" (una riga per coppia) oppure "master sku" e "handle negozi"');
    var m = {}, handlesById = {}, bad = 0, nrows = 0;
    rows.slice(1).forEach(function (r) {
      var sku = masterSku(r[cols.sku]);
      if (cols.stores) { if (!sku || !r[cols.stores]) return; }
      else {
        if (!sku || !r[cols.code]) return;
        nrows++;
        var cid = codeToId(r[cols.code]);
        if (!cid) { bad++; return; }
        if (!handlesById[cid]) handlesById[cid] = String(r[cols.code]).trim().replace(/\.0+$/, '');
        if (!m[sku]) m[sku] = [];
        if (m[sku].indexOf(cid) < 0) m[sku].push(cid);
        return;
      }
      nrows++;
      var seen = {}, list = [];
      String(r[cols.stores]).split(',').forEach(function (h) {
        h = h.trim(); if (!h || seen[h]) return; seen[h] = 1;
        var id = handleToId(h);
        if (!id) { bad++; return; }
        if (!handlesById[id]) handlesById[id] = h;
        if (list.indexOf(id) < 0) list.push(id);
      });
      m[sku] = (m[sku] || []).concat(list.filter(function (x) { return (m[sku] || []).indexOf(x) < 0; }));
    });
    return { m: m, handlesById: handlesById, stats: { rows: nrows, skus: Object.keys(m).length, stores: Object.keys(handlesById).length, bad: bad } };
  }
  function sameOriginFile(url) {
    try {
      var u = new URL(url, location.href), mm = /\/files\/([^\/]+)$/.exec(u.pathname);
      if (u.hostname === 'cdn.shopify.com' && mm) return location.origin + '/cdn/shop/files/' + mm[1] + u.search;
      return u.href;
    } catch (e) { return url; }
  }
  function loadFile(url, forceFull) {
    var key = mem['file:' + url];
    if (key) return key;
    if (!forceFull) {
      try { var c = JSON.parse(localStorage.getItem(FILE_KEY) || 'null'); if (c && c.url === url && c.m) return (mem['file:' + url] = Promise.resolve({ m: c.m, stats: c.stats })); } catch (e) {}
    }
    mem['file:' + url] = fetch(sameOriginFile(url)).then(function (r) {
      if (!r.ok) throw new Error('File non raggiungibile (' + r.status + ')');
      return r.arrayBuffer();
    }).then(function (buf) {
      var head = new Uint8Array(buf.slice(0, 2));
      var p = (head[0] === 0x50 && head[1] === 0x4b) ? parseXlsx(buf) : Promise.resolve(parseCsv(new TextDecoder().decode(buf)));
      return p;
    }).then(function (rows) {
      var res = tableToData(rows);
      try { localStorage.setItem(FILE_KEY, JSON.stringify({ url: url, m: res.m, stats: res.stats })); } catch (e) {}
      return res;
    });
    mem['file:' + url].catch(function () { delete mem['file:' + url]; });
    return mem['file:' + url];
  }

  /* ---------- elenco negozi: API ufficiale Storepoint, con ripiego sul widget ---------- */
  function rowsFromOfficial(list) {
    var rows = [];
    list.forEach(function (l) {
      var id = '';
      (l.customFields || []).forEach(function (c) { if (c.key === 'id' && c.value) id = String(c.value).toLowerCase(); });
      if (!id) return;
      var mono = /^frau/i.test(l.name || '');
      var tg = l.tags && !Array.isArray(l.tags) ? l.tags : {};
      Object.keys(tg).forEach(function (g) { ((tg[g] && tg[g].items) || []).forEach(function (i) { if (/monobrand/i.test(i.value || '')) mono = true; }); });
      rows.push([id, l.name || '', (l.address && l.address.formatted) || '', (l.contact && l.contact.phone) || '',
        l.coordinates && l.coordinates.lat, l.coordinates && l.coordinates.lng, mono ? 1 : 0]);
    });
    return rows;
  }
  function rowsFromWidget(j) {
    var rows = [];
    ((j.results && j.results.locations) || []).forEach(function (l) {
      var cf = {}; try { cf = JSON.parse(l.custom_fields || '{}'); } catch (e) {}
      var id = cf && !Array.isArray(cf) ? String(cf[ID_FIELD] || '').toLowerCase() : '';
      if (!id) return;
      rows.push([id, l.name || '', l.streetaddress || '', l.phone || '', l.loc_lat, l.loc_long,
        (norm(l.tags).indexOf('monobrand') > -1 || /^frau/i.test(l.name || '')) ? 1 : 0]);
    });
    return rows;
  }
  function fetchOfficial(token) {
    var base = 'https://api.storepoint.co/public/v1/' + token + '/locations?all=true&limit=500', all = [];
    function page(off) {
      return fetch(base + '&offset=' + off).then(function (r) { return r.json(); }).then(function (j) {
        if (!j || !j.success || !j.data) throw new Error('API Storepoint non disponibile');
        all = all.concat(j.data.locations || []);
        return j.data.pagination && j.data.pagination.hasMore ? page(off + 500) : all;
      });
    }
    return page(0).then(rowsFromOfficial);
  }
  function fetchWidget(token) {
    return fetch('https://api.storepoint.co/v1/' + token + '/locations?rq').then(function (r) { return r.json(); }).then(rowsFromWidget);
  }
  function loadAll(token) {
    token = token || DEFAULT_TOKEN;
    if (mem[token]) return mem[token];
    try {
      var c = JSON.parse(localStorage.getItem(STORES_KEY) || 'null');
      if (c && c.token === token && c.rows && Date.now() - c.t < STORES_TTL) return (mem[token] = Promise.resolve(c.rows));
    } catch (e) {}
    mem[token] = fetchOfficial(token).catch(function () { return fetchWidget(token); }).then(function (rows) {
      if (!rows.length) throw new Error('Nessun negozio');
      try { localStorage.setItem(STORES_KEY, JSON.stringify({ token: token, t: Date.now(), rows: rows })); } catch (e) {}
      return rows;
    });
    mem[token].catch(function () { delete mem[token]; });
    return mem[token];
  }
  function fetchStores(token, ids, cb, fail) {
    loadAll(token).then(function (rows) {
      var have = {}, wanted = {}, out = [];
      rows.forEach(function (r) { have[r[0]] = 1; });
      expandIds(ids, have).forEach(function (i) { wanted[i] = 1; });
      rows.forEach(function (r) {
        if (!wanted[r[0]]) return;
        out.push({ name: r[1], addr: r[2], phone: r[3], lat: r[4], lng: r[5], mono: !!r[6] });
      });
      out.sort(function (a, b) { return a.name.localeCompare(b.name); });
      cb(out);
    }).catch(fail);
  }

  /* ---------- blocco ---------- */
  function init(root) {
    if (root.getAttribute('data-sa-ready')) return;
    root.setAttribute('data-sa-ready', '1');
    var d = root.dataset;
    var base = T[d.lang] || T.en;
    function txt(key, over) { return over ? over : base[key]; }
    var t = {
      btn: txt('btn', d.label), notice: txt('notice', d.notice), search: txt('search', d.search),
      empty: txt('empty', d.empty), dir: txt('dir', d.dir), locator: txt('locator', d.locatorLabel),
      mono: base.mono, multi: base.multi, stores: base.stores, store: base.store,
      loading: base.loading, error: base.error, close: base.close,
      air: base.air, road: base.road, noticeShort: base.noticeShort, call: base.call, route: base.route, found: base.found, foundOne: base.foundOne, near: base.near, within: base.within, locFail: base.locFail, mapFail: base.mapFail
    };
    var showMap = flag(d.showMap, true), mapRadius = parseInt(d.mapRadius, 10) || 50;
    var OSM_TILES = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png', tilesUrl = d.mapTiles || OSM_TILES;
    var showNotice = flag(d.showNotice, true), showSearch = flag(d.showSearch, true), showTypes = flag(d.showTypes, true);
    var design = d.design === 'true', token = /^[0-9a-f]{8,32}$/i.test(d.spToken || '') ? d.spToken : DEFAULT_TOKEN;
    var sku = d.sku, master = masterSku(sku), fileUrl = d.fileUrl || '';

    function done(map, info) {
      var ids = map[sku] || map[master] || [];
      if (ids.length || design) { build(ids); root.hidden = false; }
      if (design) diagnostics(info);
    }
    function legacy(err) {
      if (err) { done({}, { error: err.message, legacy: 0 }); return; }
      loadData(d.dataSrc, function () {
        var map = window.FRAU_STORE_AVAILABILITY || {};
        done(map, { error: err && Object.keys(map).length ? err.message + ' (uso il file dati di riserva)' : (err && err.message), legacy: Object.keys(map).length });
      });
    }
    if (fileUrl) loadFile(fileUrl, design).then(function (res) { done(res.m, { src: 'file', stats: res.stats, handlesById: res.handlesById, url: fileUrl }); }).catch(legacy);
    else legacy(null);

    function diagnostics(info) {
      var box = el('div', 'sa-diag');
      box.appendChild(el('div', 'sa-diag__title', 'Verifica disponibilit\u00e0: stato dei dati'));
      var body = el('div', 'sa-diag__body'); box.appendChild(body);
      root.appendChild(box);
      if (!info || info.src !== 'file') {
        body.textContent = info && info.legacy ? 'Sto usando il file dati nel tema (' + info.legacy + ' prodotti). ' + (info.error || 'Carica il file nel campo "File disponibilit\u00e0 negozi" per usare l\'Excel di Frau.') : (info && info.error) || 'Nessun file di disponibilit\u00e0 trovato.';
        return;
      }
      var s = info.stats;
      body.textContent = 'File letto: ' + s.skus + ' prodotti, ' + s.stores + ' negozi' + (s.bad ? ', ' + s.bad + ' negozi con formato non riconosciuto' : '') + '. Controllo il locator\u2026';
      loadAll(token).then(function (rows) {
        var have = {}; rows.forEach(function (r) { have[r[0]] = 1; });
        var missing = Object.keys(info.handlesById).filter(function (id) { return !expandIds([id], have).some(function (k) { return have[k]; }); });
        body.textContent = 'File letto: ' + s.skus + ' prodotti, ' + s.stores + ' negozi. Trovati nel locator: ' + (s.stores - missing.length) + '. Non trovati: ' + missing.length + '.' + (s.bad ? ' Formato non riconosciuto: ' + s.bad + '.' : '');
        if (missing.length) {
          var a = el('a', 'sa-diag__link', 'Scarica l\'elenco dei negozi mancanti (CSV)');
          a.href = '#'; a.addEventListener('click', function (e) {
            e.preventDefault();
            var csv = 'negozio nel file;codice atteso\n' + missing.map(function (id) { return info.handlesById[id] + ';' + id; }).join('\n');
            var l = document.createElement('a'); l.href = URL.createObjectURL(new Blob(['\ufeff' + csv], { type: 'text/csv' })); l.download = 'negozi-mancanti.csv'; l.click();
          });
          body.appendChild(document.createElement('br')); body.appendChild(a);
        }
      }).catch(function () { body.textContent += ' Impossibile leggere l\'elenco negozi dal locator.'; });
    }

    function build(ids) {
      var btn = root.querySelector('[data-sa-open]');
      btn.textContent = t.btn;

      var ov = el('div', 'sa-ov');
      ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true'); ov.setAttribute('aria-label', t.btn);
      var panel = el('div', 'sa-ov__panel' + (showMap ? ' has-map' : ' no-map'));

      var mapEl = showMap ? el('div', 'sa-ov__map') : null;
      var head = el('div', 'sa-ov__head');
      var top = el('div', 'sa-ov__top');
      var search = el('input', 'sa-ov__search');
      search.type = 'search'; search.placeholder = t.search; search.setAttribute('aria-label', t.search);
      var sbox = el('div', 'sa-ov__sbox'); sbox.appendChild(search);
      if (showSearch) top.appendChild(sbox);
      var close = el('button', 'sa-ov__close', '\u00d7');
      close.type = 'button'; close.setAttribute('aria-label', t.close); top.appendChild(close);
      head.appendChild(top);

      var chips = el('div', 'sa-ov__chips');
      function chip(label) { var c = el('button', 'sa-chip', label); c.type = 'button'; c.setAttribute('aria-pressed', 'false'); return c; }
      var cMono, cMulti, locBtn;
      if (showTypes) { cMono = chip(t.mono); cMulti = chip(t.multi); chips.appendChild(cMono); chips.appendChild(cMulti); }
      if (showMap) { locBtn = chip(t.near); locBtn.className += ' sa-chip--loc'; chips.appendChild(locBtn); }
      if (chips.children.length) head.appendChild(chips);
      var count = el('div', 'sa-ov__count'); head.appendChild(count);
      if (showNotice && t.notice) {
        var note = el('div', 'sa-ov__note is-collapsed');
        note.appendChild(el('span', 'sa-ov__short', d.notice ? d.notice : t.noticeShort));
        note.appendChild(el('span', 'sa-ov__full', t.notice));
        note.setAttribute('role', 'button'); note.tabIndex = 0;
        note.addEventListener('click', function () { note.classList.toggle('is-collapsed'); });
        head.appendChild(note);
      }

      var cards = el('div', 'sa-ov__cards');
      var attr = el('div', 'sa-ov__attr');
      function setAttr() { attr.innerHTML = '\u00a9 <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> \u00b7 <a href="https://leafletjs.com" target="_blank" rel="noopener">Leaflet</a>' + (/mapbox\.com/.test(tilesUrl) ? ' \u00b7 \u00a9 <a href="https://www.mapbox.com/about/maps/" target="_blank" rel="noopener">Mapbox</a>' : ''); }
      if (showMap) setAttr();
      var compact = window.innerWidth < 750, infoBtn = null;
      if (showMap && compact) {
        attr.className += ' is-compact';
        infoBtn = el('button', 'sa-ov__info', 'i'); infoBtn.type = 'button'; infoBtn.setAttribute('aria-label', 'Crediti');
        infoBtn.addEventListener('click', function () { attr.classList.toggle('is-open'); });
      }
      var foot = el('div', 'sa-ov__foot');
      if (d.updated) foot.appendChild(el('span', '', d.updated));
      if (d.locatorUrl) { var la = el('a', '', t.locator); la.href = d.locatorUrl; foot.appendChild(la); }
      if (mapEl) panel.appendChild(mapEl);
      panel.appendChild(head); panel.appendChild(cards);
      if (foot.children.length) panel.appendChild(foot);
      if (showMap) panel.appendChild(attr);
      if (infoBtn) panel.appendChild(infoBtn);
      ov.appendChild(panel);
      document.body.appendChild(ov);

      var stores = [], rowsNow = [], userPos = null, origin = null, geo = { q: '', pos: null, seq: 0, cache: {} }, roadCache = {}, roadCalls = 0, roadKey = '', mbKey = '', autoLocate = null, autoTried = false, map = null, layer = null, pts = [], singles = {}, active = -1, interacted = false, leafletFail = false, scrollT = null, wantFit = true;
      var PW = window.innerWidth < 750 ? 24 : 30, PH = PW * 4 / 3, CS = window.innerWidth < 750 ? 36 : 44;
      var PIN = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 40" width="' + PW + '" height="' + PH + '"><path d="M15 0C6.7 0 0 6.7 0 15c0 10 15 25 15 25s15-15 15-25C30 6.7 23.3 0 15 0z" fill="#000"/></svg>';

      function km(lat1, lng1, lat2, lng2) {
        var r = Math.PI / 180, dy = (lat2 - lat1) * r, dx = (lng2 - lng1) * r,
            h = Math.sin(dy / 2) * Math.sin(dy / 2) + Math.cos(lat1 * r) * Math.cos(lat2 * r) * Math.sin(dx / 2) * Math.sin(dx / 2);
        return 12742 * Math.asin(Math.sqrt(h));
      }
      function dirUrl(s) {
        return 'https://www.google.com/maps/dir/?api=1&destination=' + (s.lat && s.lng ? s.lat + ',' + s.lng : encodeURIComponent(s.name + ' ' + s.addr));
      }
      // cerca il luogo digitato (citt\u00e0, CAP) su OpenStreetMap, nei soli paesi dove ci sono negozi
      function geocode(q, cb) {
        if (geo.cache[q] !== undefined) return cb(geo.cache[q]);
        var cc = {};
        var VALID = ' it at de ch fr es pt nl be lu gr tr si hr sk cz pl hu ro bg rs ba me mk al cy mt gb ie dk se no fi ee lv lt ua by md ru az ge am kz mn il ae sa kw qa jp cn kr us ca mx au ';
        stores.forEach(function (s) { var m = /,\s*([A-Z]{2})\s*$/.exec(s.addr || ''); if (m && VALID.indexOf(' ' + m[1].toLowerCase() + ' ') > -1) cc[m[1].toLowerCase()] = 1; });
        var url = 'https://nominatim.openstreetmap.org/search?format=json&limit=1&accept-language=' + (d.lang || 'it') + '&q=' + encodeURIComponent(q) + (Object.keys(cc).length ? '&countrycodes=' + Object.keys(cc).join(',') : '');
        var done = false, to = setTimeout(function () { if (!done) { done = true; cb(null); } }, 6000);
        function ask(retry) {
          fetch(url).then(function (r) { return r.json(); }).then(function (j) {
            if (done) return; done = true; clearTimeout(to);
            var pos = j && j[0] && (j[0].class === 'place' || j[0].class === 'boundary') && isFinite(parseFloat(j[0].lat)) ? { lat: parseFloat(j[0].lat), lng: parseFloat(j[0].lon) } : null;
            geo.cache[q] = pos; cb(pos);
          }).catch(function () {
            if (done) return;
            if (retry) return setTimeout(function () { ask(false); }, 1300);
            done = true; clearTimeout(to); cb(null);
          });
        }
        ask(true);
      }
      var geoT = null;
      function lookup(now) {
        clearTimeout(geoT);
        var q = norm(search.value).trim();
        if (q.length < 3) { geo.q = ''; geo.pos = null; geo.seq++; wantFit = true; render(); return; }
        if (userPos) { userPos = null; if (locBtn) locBtn.setAttribute('aria-pressed', 'false'); }
        count.textContent = t.loading;
        var seq = ++geo.seq;
        geoT = setTimeout(function () {
          geocode(q, function (pos) {
            if (seq !== geo.seq) return;
            geo.q = q; geo.pos = pos; wantFit = true; render();
          });
        }, now ? 0 : 600);
      }
      // stessa mappa dello Store Locator: stile chiaro di Mapbox con la chiave che Storepoint ha gi\u00e0 nelle sue impostazioni
      function tileSource(cb) {
        if (d.mapTiles) { var mk = /access_token=([\w.-]+)/.exec(d.mapTiles); if (mk) mbKey = mk[1]; return cb(d.mapTiles); }
        fetch('https://api26.storepoint.co/v2/' + token + '/settings').then(function (r) { return r.json(); }).then(function (j) {
          var mp = j && j.settings && j.settings.map_provider;
          if (typeof mp === 'string') mp = JSON.parse(mp);
          var okKey = mp && mp.use === 'mapbox' && /^pk\.[\w.-]+$/.test(mp.key || '');
          if (okKey) mbKey = mp.key;
          cb(okKey ? 'https://api.mapbox.com/styles/v1/mapbox/light-v11/tiles/512/{z}/{x}/{y}{r}?access_token=' + mp.key : OSM_TILES);
        }).catch(function () { cb(OSM_TILES); });
      }
      // distanza su strada: percorso vero (Directions) per i 10 negozi pi\u00f9 vicini in linea d'aria; gli altri non mostrano distanza.
      // L'API Matrix \u00e8 stata provata e scartata: gonfia le distanze fino a +50% rispetto al percorso vero.
      function fetchRoad(o, rk) {
        roadCache[rk] = {}; roadCalls++;
        var near = stores.filter(hasCoords).sort(function (a, b) { return a.dist - b.dist; }).slice(0, 10), left = near.length;
        near.forEach(function (s) {
          fetch('https://api.mapbox.com/directions/v5/mapbox/driving/' + o.lng + ',' + o.lat + ';' + parseFloat(s.lng) + ',' + parseFloat(s.lat) + '?overview=false&access_token=' + mbKey)
            .then(function (r) { return r.json(); }).then(function (j) {
              var v = j && j.routes && j.routes[0] && j.routes[0].distance;
              if (typeof v === 'number') roadCache[rk][s.name + '|' + s.lat] = v;
            }).catch(function () {}).then(function () { if (--left === 0 && rk === roadKey) render(); });
        });
      }
      function loadLeaflet(cb) {
        if (window.L) return cb();
        if (leafletFail) return cb(new Error('x')); if (window.__saLq) { window.__saLq.push(cb); return; } window.__saLq = [cb];
        var css = document.createElement('link'); css.rel = 'stylesheet'; css.href = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css';
        css.integrity = 'sha512-h9FcoyWjHcOcmEVkxOfTLnmZFWIH0iZhZT1H2TbOq55xssQGEJHEaIm+PgoUaZbRvQTNTluNOEfb1ZRy6D3BOw=='; css.crossOrigin = '';
        document.head.appendChild(css);
        var js = document.createElement('script'); js.src = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js';
        js.integrity = 'sha512-puJW3E/qXDqYp9IfhAI54BJEaWIfloJ7JWs7OeD5i6ruC9JZL1gERT1wjtwXFlh7CjE7ZJ+/vcRZRkIYIb6p4g=='; js.crossOrigin = '';
        js.onload = function () { var q = window.__saLq; window.__saLq = null; q.forEach(function (f) { f(); }); }; js.onerror = function () { leafletFail = true; var q = window.__saLq; window.__saLq = null; q.forEach(function (f) { f(new Error('x')); }); };
        document.head.appendChild(js);
      }
      function hasCoords(s) { return isFinite(parseFloat(s.lat)) && isFinite(parseFloat(s.lng)); }
      function applyActive() {
        Object.keys(singles).forEach(function (k) { var e = singles[k].getElement(); if (e) e.classList.toggle('is-active', +k === active); });
      }
      function setActive(i, from) {
        active = i;
        [].forEach.call(cards.children, function (c, k) { c.classList.toggle('is-active', k === i); });
        var s = rowsNow[i];
        if (from === 'pin' && cards.children[i]) cards.children[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        if (map && s && hasCoords(s)) map.setView([parseFloat(s.lat), parseFloat(s.lng)], Math.max(map.getZoom(), 13), { animate: true });
        applyActive();
      }
      // raggruppa i pin vicini (come il locator) e disegna goccia nera o cerchio con il numero
      function renderClusters() {
        if (!map) return;
        layer.clearLayers(); singles = {};
        var R = 46, z = map.getZoom(), groups = [];
        pts.forEach(function (p) {
          var pp = map.project([p.la, p.lo], z), g = null;
          for (var k = 0; k < groups.length; k++) { if (Math.abs(groups[k].x - pp.x) < R && Math.abs(groups[k].y - pp.y) < R) { g = groups[k]; break; } }
          if (g) { var n = g.items.length; g.items.push(p); g.x = (g.x * n + pp.x) / (n + 1); g.y = (g.y * n + pp.y) / (n + 1); }
          else groups.push({ x: pp.x, y: pp.y, items: [p] });
        });
        groups.forEach(function (g) {
          if (g.items.length === 1) {
            var p = g.items[0];
            var m = L.marker([p.la, p.lo], { icon: L.divIcon({ className: 'sa-pin', html: PIN, iconSize: [PW, PH], iconAnchor: [PW / 2, PH] }), title: rowsNow[p.i].name, keyboard: true });
            m.on('click', function () { interacted = true; setActive(p.i, 'pin'); });
            layer.addLayer(m); singles[p.i] = m;
          } else {
            var b = L.latLngBounds(g.items.map(function (p) { return [p.la, p.lo]; }));
            var cm = L.marker(b.getCenter(), { icon: L.divIcon({ className: 'sa-cluster-wrap', html: '<div class="sa-cluster">' + g.items.length + '</div>', iconSize: [CS, CS], iconAnchor: [CS / 2, CS / 2] }), keyboard: false });
            cm.on('click', function () { map.fitBounds(b, { padding: [70, 70], maxZoom: 16 }); });
            layer.addLayer(cm);
          }
        });
        if (origin) {
          var oc = origin.place ? '#000' : '#4285f4';
          layer.addLayer(L.circleMarker([origin.lat, origin.lng], { radius: 18, stroke: false, fillColor: oc, fillOpacity: .2, interactive: false }));
          layer.addLayer(L.circleMarker([origin.lat, origin.lng], { radius: 7, color: '#fff', weight: 3, fillColor: oc, fillOpacity: 1, interactive: false }));
        }
        applyActive();
      }
      function drawMap() {
        if (!map) return;
        pts = [];
        rowsNow.forEach(function (s, i) { if (hasCoords(s)) pts.push({ i: i, la: parseFloat(s.lat), lo: parseFloat(s.lng) }); });
        renderClusters();
        if (!wantFit) return;
        wantFit = false;
        var pad = window.innerWidth < 750 ? { paddingTopLeft: [30, 250], paddingBottomRight: [30, 250] } : { padding: [60, 60] };
        if (origin) {
          var b = L.latLngBounds([[origin.lat, origin.lng]]), near = 0;
          rowsNow.forEach(function (s) { if (s.dist != null && s.dist <= mapRadius && hasCoords(s)) { b.extend([parseFloat(s.lat), parseFloat(s.lng)]); near++; } });
          if (!near) { var nr = rowsNow.filter(hasCoords)[0]; if (nr) b.extend([parseFloat(nr.lat), parseFloat(nr.lng)]); }
          map.fitBounds(b, Object.assign({ maxZoom: 12, animate: false }, pad));
        } else if (pts.length) map.fitBounds(L.latLngBounds(pts.map(function (p) { return [p.la, p.lo]; })), Object.assign({ maxZoom: 13, animate: false }, pad));
        renderClusters();
      }
      function ensureMap() {
        if (!showMap) return;
        loadLeaflet(function (err) {
          if (err) { mapEl.textContent = t.mapFail; mapEl.className += ' sa-ov__empty'; return; }
          if (!map) {
            map = L.map(mapEl, { zoomControl: false, attributionControl: false }).setView([42.5, 12.5], 5);
            L.control.zoom({ position: window.innerWidth < 750 ? 'bottomright' : 'topright' }).addTo(map);
            tileSource(function (url) {
              tilesUrl = url; setAttr();
              var mb = /mapbox\.com/.test(url);
              L.tileLayer(url, { maxZoom: 18, tileSize: mb ? 512 : 256, zoomOffset: mb ? -1 : 0, detectRetina: !mb, r: L.Browser.retina ? '@2x' : '' }).addTo(map);
              if (origin && mbKey) render();
            });
            layer = L.layerGroup().addTo(map);
            map.on('zoomend', renderClusters);
          }
          setTimeout(function () { map.invalidateSize(); if (origin) wantFit = true; drawMap(); }, 60);
        });
      }

      function render() {
        count.classList.remove('is-alert');
        var q = norm(search.value);
        var place = q.trim() && geo.q === q.trim() && geo.pos ? { lat: geo.pos.lat, lng: geo.pos.lng, place: true } : null;
        origin = place || userPos;
        roadKey = origin ? origin.lat.toFixed(3) + ',' + origin.lng.toFixed(3) : '';
        var rc = roadKey && roadCache[roadKey];
        stores.forEach(function (s) {
          s.dist = origin && hasCoords(s) ? km(origin.lat, origin.lng, parseFloat(s.lat), parseFloat(s.lng)) : null;
          s.road = rc && rc[s.name + '|' + s.lat] != null ? rc[s.name + '|' + s.lat] : null;
        });
        var onlyMono = cMono && cMono.getAttribute('aria-pressed') === 'true', onlyMulti = cMulti && cMulti.getAttribute('aria-pressed') === 'true';
        var rows = stores.filter(function (s) {
          if (onlyMono && !onlyMulti && !s.mono) return false;
          if (onlyMulti && !onlyMono && s.mono) return false;
          return place || !q || norm(s.name + ' ' + s.addr).indexOf(q) > -1;
        });
        function sortKey(x) { return x.dist == null ? 1e9 : (x.road != null ? x.road / 1000 : 1000 + x.dist); }
        if (origin) rows.sort(function (a, b) { return sortKey(a) - sortKey(b); });
        rowsNow = rows; active = -1;
        cards.innerHTML = '';
        if (origin) {
          var n = rows.filter(function (s) { return s.dist != null && (s.road != null ? s.road / 1000 : s.dist) <= mapRadius; }).length;
          count.textContent = n + ' ' + (n === 1 ? t.store : t.stores) + ' ' + t.within + ' ' + mapRadius + ' km';
        } else count.textContent = rows.length + ' ' + (rows.length === 1 ? t.store : t.stores) + ' ' + (rows.length === 1 ? t.foundOne : t.found);
        if (!rows.length) cards.appendChild(el('div', 'sa-ov__empty', t.empty));
        rows.forEach(function (s, i) {
          var c = el('div', 'sa-card');
          var tp = el('div', 'sa-card__top'); tp.appendChild(el('div', 'sa-card__name', s.name));
          if (s.road != null) { var dd = el('div', 'sa-card__dist', Math.round(s.road / 1000) + ' km'); dd.appendChild(el('small', '', t.road)); tp.appendChild(dd); }
          c.appendChild(tp);
          var ty = el('div', 'sa-card__type', s.mono ? t.mono : t.multi);
          var totN = origin ? rows.filter(function (x) { return x.dist != null && (x.road != null ? x.road / 1000 : x.dist) <= mapRadius; }).length : rows.length;
          if (origin && i < totN) ty.appendChild(el('span', 'sa-card__n', ' \u00b7 ' + (i + 1) + '/' + totN));
          c.appendChild(ty);
          c.appendChild(el('div', 'sa-card__addr', s.addr));
          if (d.rowLabel) c.appendChild(el('div', 'sa-ov__row' + (d.rowGreen === 'true' ? ' is-green' : ''), d.rowLabel));
          if (s.phone) {
            var ph = el('a', 'sa-line sa-line--phone'); ph.href = 'tel:' + String(s.phone).replace(/[^\d+]/g, '');
            ph.appendChild(el('span', '', s.phone)); c.appendChild(ph);
          }
          var dl = el('a', 'sa-line sa-line--dir'); dl.target = '_blank'; dl.rel = 'noopener'; dl.href = dirUrl(s);
          dl.appendChild(el('span', '', t.dir)); c.appendChild(dl);
          c.addEventListener('click', function (e) { if (e.target.closest('a')) return; interacted = true; setActive(i, 'card'); });
          cards.appendChild(c);
        });
        ov.style.setProperty('--sa-h', cards.offsetHeight + 'px');
        if (map) drawMap();
        if (origin && mbKey && !roadCache[roadKey] && roadCalls < 6) fetchRoad(origin, roadKey);
      }

      cards.addEventListener('scroll', function () {
        if (!interacted || window.innerWidth >= 750) return;
        clearTimeout(scrollT);
        scrollT = setTimeout(function () {
          var mid = cards.scrollLeft + cards.clientWidth / 2, best = -1, bd = 1e9;
          [].forEach.call(cards.children, function (c, k) { var dd = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (dd < bd) { bd = dd; best = k; } });
          if (best > -1 && best !== active) setActive(best, 'card-scroll');
        }, 140);
      }, { passive: true });
      cards.addEventListener('pointerdown', function () { interacted = true; });

      var loaded = false;
      function open() {
        ov.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        setTimeout(function () { try { close.focus({ preventScroll: true }); } catch (e) {} }, 60);
        if (loaded) { if (map) setTimeout(function () { map.invalidateSize(); }, 60); return; }
        cards.innerHTML = ''; cards.appendChild(el('div', 'sa-ov__empty', t.loading));
        ensureMap();
        fetchStores(token, ids, function (s) { stores = s; loaded = true; wantFit = true; render(); if (autoLocate && !autoTried) { autoTried = true; autoLocate(); } },
          function () { cards.innerHTML = ''; cards.appendChild(el('div', 'sa-ov__empty', t.error)); });
      }
      function shut() { ov.classList.remove('is-open'); document.documentElement.style.overflow = ''; btn.focus(); }

      function warm() { loadAll(token).catch(function () {}); if (showMap) loadLeaflet(function () {}); }
      btn.addEventListener('pointerenter', warm, { once: true });
      btn.addEventListener('touchstart', warm, { once: true, passive: true });
      btn.addEventListener('focus', warm, { once: true });
      btn.addEventListener('click', open);
      close.addEventListener('click', shut);
      ov.addEventListener('click', function (e) { if (e.target === ov) shut(); });
      document.addEventListener('keydown', function (e) {
        if (!ov.classList.contains('is-open')) return;
        if (e.key === 'Escape') { shut(); return; }
        if (e.key !== 'Tab') return;
        var f = [].filter.call(ov.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])'), function (x) { return !x.disabled && x.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1], cur = document.activeElement;
        if (!ov.contains(cur)) { e.preventDefault(); first.focus(); }
        else if (e.shiftKey && cur === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && cur === last) { e.preventDefault(); first.focus(); }
      });
      search.addEventListener('input', function () { lookup(false); });
      search.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); lookup(true); } });
      function toggle(c, other) { c.addEventListener('click', function () { var on = c.getAttribute('aria-pressed') !== 'true'; c.setAttribute('aria-pressed', on ? 'true' : 'false'); if (on && other) other.setAttribute('aria-pressed', 'false'); wantFit = true; render(); }); }
      if (cMono) { toggle(cMono, cMulti); toggle(cMulti, cMono); }
      if (locBtn) {
        function locate(silent) {
          if (userPos) { userPos = null; stores.forEach(function (s) { s.dist = null; }); locBtn.setAttribute('aria-pressed', 'false'); wantFit = true; render(); return; }
          if (!navigator.geolocation) { if (!silent) count.textContent = t.locFail; return; }
          if (!silent) count.textContent = t.loading;
          navigator.geolocation.getCurrentPosition(function (p) {
            if (silent && (search.value.trim() || userPos)) return;
            userPos = { lat: p.coords.latitude, lng: p.coords.longitude };
            search.value = ''; geo.q = ''; geo.pos = null; geo.seq++;
            stores.forEach(function (s) { s.dist = hasCoords(s) ? km(userPos.lat, userPos.lng, parseFloat(s.lat), parseFloat(s.lng)) : null; });
            locBtn.setAttribute('aria-pressed', 'true'); wantFit = true; if (map) map.invalidateSize(); render();
          }, function () { render(); if (!silent) { count.textContent += ' \u00b7 ' + t.locFail; count.classList.add('is-alert'); } }, { enableHighAccuracy: false, timeout: silent ? 8000 : 10000, maximumAge: 300000 });
        }
        locBtn.addEventListener('click', function () { locate(false); });
        autoLocate = function () { locate(true); };
      }
    }
  }

  function scan() { document.querySelectorAll('[data-sa-root]').forEach(init); }
  window.__saTest = { parseXlsx: parseXlsx, parseCsv: parseCsv, tableToData: tableToData, handleToId: handleToId, codeToId: codeToId, expandIds: expandIds, rowsFromOfficial: rowsFromOfficial, sameOriginFile: sameOriginFile };
  scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:block:select', scan);
})();
